m = require 'mithril'

ActionFactories = require '../../state/ActionFactories'
IdGenerator 	= require '../../lib/IdGenerator'

CommonViews 	= require '../components/CommonViews'
Breadcrumbs 	= require '../components/Breadcrumbs'
ControlBlock 	= require '../components/ControlBlock'

NewGamePage = {
	controller: (args) ->
		validate = (ctrl) ->
			errors = []
			errors.push('At least one player needed') unless ctrl.players().length > 0
			errors.push('Date is required') unless ctrl.date()? and ctrl.date().length is 10
			return {
				errors: errors
				isValid: errors.length is 0
			}

		@date = m.prop new Date().toISOString()[0...10]
		@label = m.prop null
		@players = m.prop []
		@errors = m.prop []

		clearErrors = () => @errors []
		@onCancel = () ->
			clearErrors()
			m.route '/'
		@onAddPlayer = (e) ->
			p = {name: m.prop ''}
			@players @players().concat p
			clearErrors()
		@onRemovePlayer = (ix) ->
			@players( (p for p, i in @players() when i isnt ix) )
			clearErrors()
		@onCreateGame = () ->
			status = validate @
			@errors status.errors
			if status.isValid
				g = {
					id: IdGenerator.generate()
					label: if @label()?.length > 1 then @label() else @date()
					date: @date()
					players: {id: IdGenerator.generate(), name: p.name()} for p in @players()
					rounds: []
				}
				args.addGame g
				m.route "/game/#{g.id}"
		return @

	view: (ctrl) ->
		CommonViews.page [
			m Breadcrumbs, {items: [
				{url: '/', label: 'Games', icon: CommonViews.icons.home}
				{label: 'Add game'}
			]}
			CommonViews.pageHeading 'Add Game'
			m 'form', {
				onsubmit: (e) ->
					e.preventDefault()
					ctrl.onCreateGame()
			}, [
				CommonViews.errors ctrl.errors()

				m 'p', 'Label (optional)'
				m 'input[type=text]', {
					value: ctrl.label()
					onchange: m.withAttr 'value', ctrl.label
				}

				m 'p', 'Date'
				m 'input[type=date][required]', {
					value: ctrl.date()
					onchange: m.withAttr 'value', ctrl.date
				}

				m 'p', 'Players'
				CommonViews.list ctrl.players(), 
					(p, ix) -> [
						m 'input[type=text][required]', {
							value: p.name()
							onchange: m.withAttr 'value', p.name
						}
						m 'button[type=button]', {onclick: ctrl.onRemovePlayer.bind ctrl, ix}, [
							CommonViews.icon CommonViews.icons.bin, 'button_icon'
						]
					],
					'No players yet.  Add below.'
				m ControlBlock, {content: [
					m 'button[type=button]', {onclick: ctrl.onAddPlayer.bind ctrl}, [
						CommonViews.icon CommonViews.icons.plus, 'button_icon'
						'Add player'
					]
				]}

				m 'p', 'When you have finished editing the above details, click save to create the game so you can start entering scores.'
				m ControlBlock, {content: [
					m 'button[type=submit]', [
						CommonViews.icon CommonViews.icons.floppydisk, 'button_icon'
						'Save game'
					]
					m 'span.link', {onclick: ctrl.onCancel.bind ctrl}, 'Cancel'
				]}
			]
		]
}

module.exports = (store) ->
	m.component NewGamePage, {
		addGame: (g) -> store.dispatch ActionFactories.gameAdded g
	}